import "react-toastify/dist/ReactToastify.css";
import { useAuth0 } from "@auth0/auth0-react";
import { authClient } from "src/api/firebase";
import { getCustomFirebaseLoginToken, signInWithCustomToken } from "src/api";
import { useEffect } from "react";

export const useAuthenticate = () => {
  const auth = useAuth0();
  const user = authClient.currentUser;

  const checkSession = async () => {
    if (!auth.isAuthenticated || !user) {
      try {
        let accessToken: string | null = null;
        try {
          accessToken = await auth.getAccessTokenSilently();

          if (!accessToken) {
            throw new Error("Failed to get accessToken");
          }
        } catch (e) {
          accessToken = null;
          console.error(e);
          return;
        }

        let customLoginToken: string | null = null;
        try {
          customLoginToken = await getCustomFirebaseLoginToken(accessToken);

          if (!customLoginToken) {
            throw new Error("Failed to get custom firebase login token");
          }
        } catch (e) {
          console.error(e);
          return;
        }

        try {
          await signInWithCustomToken(customLoginToken);
        } catch (e) {
          console.error(`Error signing in with custom token: ${e}`);
        }
      } catch (error) {
        //not authorized
      }
    }
  };

  const MINUTE_MS = 900000;

  useEffect(() => {
    checkSession();
    const interval = setInterval(() => {
      checkSession();
    }, MINUTE_MS);

    return () => clearInterval(interval);
  }, []);

  return user;
};
